/**
 * Ceny na kartach kolekcji: compare_at + akcja Luxio (−10%, data-promo-price).
 */
(function (global) {
  global.kayerIsDistributorPartnerMode = function () {
    if (typeof window !== 'undefined' && typeof window.kayerIsPartnerPricingMode === 'function') {
      try {
        if (window.kayerIsPartnerPricingMode()) return true;
      } catch (e) {}
    }
    if (
      typeof document !== 'undefined' &&
      document.body &&
      (document.body.getAttribute('data-kayer-partner-pricing') === '1' ||
        document.body.getAttribute('data-kayer-distributor-partner') === '1')
    ) {
      return true;
    }
    if (
      typeof window !== 'undefined' &&
      window.KayerPartnerStorefront &&
      (window.KayerPartnerStorefront.distributor === true ||
        window.KayerPartnerStorefront.partner === true)
    ) {
      var sfRules = window.KayerPartnerStorefront.discount_rules;
      if (window.KayerPartnerStorefront.distributor === true) return true;
      if (Array.isArray(sfRules) && sfRules.some(function (r) { return r && Number(r.pct) > 0; })) return true;
    }
    try {
      if (
        typeof sessionStorage !== 'undefined' &&
        sessionStorage.getItem('kayerPartnerPreview') &&
        window.KayerPartnerPreview &&
        window.KayerPartnerPreview.admin
      ) {
        var preview = JSON.parse(sessionStorage.getItem('kayerPartnerPreview'));
        var mf = (preview && preview.metafields) || {};
        var market = (
          (preview && preview.market) ||
          mf.market ||
          mf.distributor_country ||
          ''
        ).toUpperCase();
        if (market === 'RO' || market === 'BG') return true;
        var rules = (preview && preview.discount_rules) || mf.discount_rules_json || [];
        if (typeof rules === 'string') {
          try { rules = JSON.parse(rules); } catch (err) { rules = []; }
        }
        return Array.isArray(rules) && rules.some(function (r) { return r && Number(r.pct) > 0; });
      }
    } catch (e) {}
    return false;
  };

  function promoNode(el) {
    if (!el) {
      return null;
    }
    return el.jquery ? el[0] : el;
  }

  /** PDP #ProductSection — nie używać jQuery .data(), bo bywa zbugowane po zmianie wariantu */
  global.kayerIsPinkPromoSection = function (el) {
    if (global.kayerIsDistributorPartnerMode()) {
      return false;
    }
    var node = promoNode(el);
    return !!(node && node.getAttribute && node.getAttribute('data-pink-promo') === '1');
  };

  global.kayerPinkPromoMult = function (el) {
    var node = promoNode(el);
    if (!node || !node.getAttribute) {
      return 90;
    }
    var mult = parseInt(node.getAttribute('data-pink-promo-mult'), 10);
    return isNaN(mult) ? 90 : mult;
  };

  function salePriceHtml(displayCents, compareCents, formatMoney) {
    if (!isNaN(compareCents) && compareCents > displayCents) {
      return (
        '<span class="product-price__reduced">' +
        formatMoney(displayCents) +
        '</span>' +
        '<span class="product-price__compare">' +
        formatMoney(compareCents) +
        '</span>'
      );
    }
    return formatMoney(displayCents);
  }

  function parseCents(raw) {
    var n = parseInt(raw, 10);
    return isNaN(n) ? NaN : n;
  }

  function defaultFormatMoney(cents) {
    if (
      typeof theme !== 'undefined' &&
      theme.Currency &&
      typeof theme.Currency.formatMoney === 'function' &&
      theme.moneyFormat
    ) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0z\u0142';
  }

  global.kayerCollectionCardPrice = function (opt) {
    var price = parseCents(opt.getAttribute('data-price'));
    var compare = parseCents(opt.getAttribute('data-compare'));

    if (global.kayerIsDistributorPartnerMode()) {
      return { display: price, compare: 0 };
    }

    var promo = opt.getAttribute('data-promo-price');

    if (promo) {
      var promoCents = parseCents(promo);
      var strike = price;
      if (!isNaN(compare) && compare > price) {
        strike = compare;
      }
      return { display: promoCents, compare: strike };
    }

    if (!isNaN(compare) && compare > price) {
      return { display: price, compare: compare };
    }

    return { display: price, compare: 0 };
  };

  global.kayerCollectionCardPriceHtml = function (opt, formatMoney) {
    var fmt = formatMoney || defaultFormatMoney;
    var p = global.kayerCollectionCardPrice(opt);
    if (isNaN(p.display)) {
      return '';
    }
    return salePriceHtml(p.display, p.compare, fmt);
  };

  /** PDP / sticky CTA: −10% Luxio promo */
  global.kayerPinkPromoVariantPrices = function (variant, mult) {
    mult = mult || 90;
    if (!variant || isNaN(variant.price)) {
      return null;
    }
    var price = variant.price;
    var compare = variant.compare_at_price;
    var strike = price;
    if (!isNaN(compare) && compare > price) {
      strike = compare;
    }
    return {
      display: Math.round((price * mult) / 100),
      compare: strike
    };
  };

  function findCard(sel) {
    return (
      sel.closest('[data-product-id]') ||
      sel.closest('.collection-row__product') ||
      sel.closest('.luxio-step-card')
    );
  }

  function updateCardImage(card, opt) {
    if (!card || !opt) return;
    var imgUrl = opt.getAttribute('data-img');
    if (!imgUrl) return;
    var imgEl = card.querySelector(
      '.collection-row__img--primary, .luxio-step-card__img'
    );
    if (!imgEl) return;
    imgEl.src = imgUrl;
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('data-src');
  }

  /** Wszystkie [data-variant-select] — katalog, landingi, tutorial */
  global.kayerBindVariantCardPrices = function (scope, formatMoney) {
    scope = scope || document;
    var fmt = formatMoney || defaultFormatMoney;

    scope.querySelectorAll('[data-variant-select]').forEach(function (select) {
      if (select.dataset.kayerPriceBound === 'true') {
        return;
      }
      select.dataset.kayerPriceBound = 'true';

      function updatePrice() {
        var opt = select.options[select.selectedIndex];
        if (!opt) {
          return;
        }
        var card = findCard(select);
        if (!card) {
          return;
        }
        updateCardImage(card, opt);
        var priceEl = card.querySelector('[data-variant-price]');
        var fromEl = card.querySelector(
          '.collection-row__price-from, .luxio-step-card__from'
        );
        var btn = card.querySelector('[data-add-button]');
        if (!priceEl) {
          return;
        }

        if (global.kayerIsDistributorPartnerMode()) {
          var grossCents = parseCents(opt.getAttribute('data-price'));
          if (typeof window.kayerRefreshCollectionPartnerPrice === 'function') {
            window.kayerRefreshCollectionPartnerPrice(card, grossCents);
          } else {
            try {
              document.dispatchEvent(
                new CustomEvent('kayer:card-variant-price', {
                  detail: { card: card, grossCents: grossCents },
                })
              );
            } catch (e) {}
          }
          if (fromEl) {
            fromEl.style.display = 'none';
          }
          if (btn) {
            var availablePartner = opt.getAttribute('data-available') === 'true';
            btn.disabled = !availablePartner;
          }
          var netBlockPartner = card.querySelector('[data-kayer-vat-net-block]');
          if (netBlockPartner) {
            netBlockPartner.style.display = 'none';
          }
          return;
        }

        var html = global.kayerCollectionCardPriceHtml(opt, fmt);
        if (html) {
          if (priceEl.classList.contains('luxio-step-card__price')) {
            var p = global.kayerCollectionCardPrice(opt);
            html =
              '<span class="luxio-step-card__price-reduced">' +
              fmt(p.display) +
              '</span><span class="luxio-step-card__price-compare">' +
              fmt(p.compare) +
              '</span>';
          }
          priceEl.innerHTML = html;
        }

        if (fromEl) {
          fromEl.style.display = 'none';
        }

        if (btn) {
          var available = opt.getAttribute('data-available') === 'true';
          btn.disabled = !available;
        }

        var netBlock = card.querySelector('[data-kayer-vat-net-block]');
        if (netBlock && typeof global.kayerCollectionCardPrice === 'function') {
          var priced = global.kayerCollectionCardPrice(opt);
          if (!isNaN(priced.display)) {
            netBlock.setAttribute('data-gross-cents', String(priced.display));
            // Only this card — never full-document scan (was O(n²) on /collections/luxio → INP).
            if (typeof global.kayerRefreshProductNetPriceBlock === 'function') {
              global.kayerRefreshProductNetPriceBlock(netBlock, priced.display);
            } else if (typeof global.kayerRefreshProductNetPrices === 'function') {
              global.kayerRefreshProductNetPrices();
            }
          }
        }

        var pricedForPartner = null;
        if (typeof global.kayerCollectionCardPrice === 'function') {
          pricedForPartner = global.kayerCollectionCardPrice(opt);
        }

        var centsNode = card.querySelector('[data-kayer-price-cents]');
        if (centsNode && pricedForPartner && !isNaN(pricedForPartner.display)) {
          centsNode.setAttribute('data-kayer-price-cents', String(pricedForPartner.display));
        }

        try {
          var partnerMode = global.kayerIsDistributorPartnerMode();
          var grossForEvent = partnerMode
            ? parseCents(opt.getAttribute('data-price'))
            : pricedForPartner && !isNaN(pricedForPartner.display)
              ? pricedForPartner.display
              : NaN;
          if (!isNaN(grossForEvent)) {
            document.dispatchEvent(
              new CustomEvent('kayer:card-variant-price', {
                detail: { card: card, grossCents: grossForEvent },
              })
            );
          }
        } catch (e) {}
      }

      select.addEventListener('change', updatePrice);
      updatePrice();
    });
  };

  function autoBind() {
    global.kayerBindVariantCardPrices(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoBind);
  } else {
    autoBind();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    global.kayerBindVariantCardPrices(ev.target || document);
  });
})(typeof window !== 'undefined' ? window : this);
